import { React, useState, useEffect } from "react";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import { SimpleSelect } from "./SimpleSelect";

const TIPO_USUARIO_OPCIONES = [
    { value: "VA", label: "Normal" },
    { value: "SI", label: "Notifica siempre" },
];

const EditarLeadModal = ({ open, onClose, lead }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [tipoUsuario, setTipoUsuario] = useState("VA");

    useEffect(() => {
        if (open && lead) {
            setTipoUsuario(lead.tipo_usuario || "VA");
        }
    }, [open, lead]);

    const handleGuardar = () => {
        setLoader({ ...loader, mostrar: true });

        const post = {
            id_lead: lead.id_lead,
            tipo_usuario: tipoUsuario,
            usuario: 0,
        };

        request
            .post("LeadsAgente/ActualizarLead", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "LEADS",
                    text: "Responsable actualizado con éxito",
                    icon: "success",
                    customClass: { container: "mi-superpoop" },
                });
                handleCancelar();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("LEADS", JSON.stringify(error), "error");
            });
    };

    const handleCancelar = () => {
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="editar-lead-modal-formulario">
                <div className="editar-lead-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="editar-lead-modal">
                        <PlantillaScreen
                            titulo="EDITAR RESPONSABLE"
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>
                            <LoaderScreen loader={loader} />
                            <div className="editar-lead-modal-content">
                                <div className="editar-lead-modal-content-container scroll-4">
                                    <div className="lead-form-group">
                                        <label>Usuario responsable</label>
                                        <input type="text" value={lead?.usuario || ""} disabled />
                                    </div>
                                    <div className="lead-form-group">
                                        <label>Tipo de usuario</label>
                                        <SimpleSelect
                                            options={TIPO_USUARIO_OPCIONES}
                                            value={tipoUsuario}
                                            onChange={setTipoUsuario}
                                            placeholder="Seleccione el tipo de usuario"
                                        />
                                    </div>
                                </div>
                                <div className="editar-lead-modal-buttons">
                                    <button
                                        className="editar-lead-modal-button-cancelar"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="editar-lead-modal-button-guardar"
                                        onClick={handleGuardar}
                                        disabled={loader.mostrar}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditarLeadModal;
